import React from "react";
import { useTranslation } from "react-i18next";
import { SPECIES_CLINIC_DTO } from "../enums/ApiPaths";
import { useFetch } from "./Fetching";
import useUser from "./useUser";

export default function useGetSpecies() {
  const { i18n } = useTranslation();
  const { currentClinic, roles } = useUser();
  const isMaster = roles.master;
  const apiPath = isMaster ? "/species/" : SPECIES_CLINIC_DTO;
  const { data, isLoading, error } = useFetch(
    apiPath,
    currentClinic?.id,
    "species"
  );

  const allSpecies = isMaster ? data : data?.species || [];
  const [translatedSpecies, setTranslatedSpecies] = React.useState([]);

  React.useEffect(() => {
    if (allSpecies) {
      const currentLang = i18n.language;
      const translation = allSpecies.map((species) => {
        if (species?.translations) {
          return {
            id: species.id,
            title: species?.translations[currentLang] ?? species.title,
            breed: species?.breed,
          };
        } else {
          return {
            id: species.id,
            title: species.title,
            breed: species?.breed,
          };
        }
      });
      setTranslatedSpecies(translation);
    }
  }, [allSpecies, i18n.language]);

  return { translatedSpecies, error, isLoading };
}
